<template>
  <div class="content" ref="visitChart">

    <div class="loading">
      <div class="main">
        <span></span>
      </div>
      <div class="text">客官请稍后</div>
    </div>

  </div>
</template>
<script>
  // import echarts from "echarts";
  let echarts = require('echarts');

  import {
    getRightChart
  } from "@/api/admin";

  export default {
    data() {
      return {
        Data: [],
        y1Data: [],
        y2Data: [],
      };
    },
    created() {
      this._getRightChart();
    },
    methods: {
      _getRightChart() {
        getRightChart().then((res) => {
          this.Data = res.data;
          this.y1Data = res.data.all_order;
          this.y2Data = res.data.success_order;
          this.handleSetVisitChart();

        });
      },

      handleSetVisitChart() {
        this.visitChart = echarts.init(this.$refs.visitChart);
        this.visitChart.setOption({

          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)'
          },


          series: [{
            name: '商品销量',
            type: 'pie',
            radius: [20, 140],
            center: ['50%', '50%'],
            roseType: 'area',
            itemStyle: {
              borderRadius: 5
            },
            data: this.Data
          }]
        });

      },
      handleResize() {
        this.visitChart.resize();
      },
    },
    mounted() {},
    beforeDestroy() {
      if (this.visitChart) {
        this.visitChart.dispose();
        this.visitChart = null;
      }
    },
  };
</script>
<style scoped lang="less">
  .content {
    height: 380px;
    margin-top: 0;
  }

  .loading {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    .text {
      margin-top: 10px;
      font-size: 14px;
      text-align: center;
    }

    .main {
      width: 80px;
      height: 80px;
      border-radius: 50%;
      margin: 0 auto;
      position: relative;
      border: 5px solid lightgreen;
      -webkit-animation: turn 2s linear infinite;
    }

    .main span {
      display: inline-block;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      background: lightgreen;
      position: absolute;
      left: 50%;
      margin-top: -15px;
      margin-left: -15px;
      -webkit-animation: changeBgColor 2s linear infinite;
    }

    @-webkit-keyframes changeBgColor {
      0% {
        background: lightgreen;
      }

      100% {
        background: lightblue;
      }
    }

    @-webkit-keyframes turn {
      0% {
        -webkit-transform: rotate(0deg);
        border-color: lightgreen;
      }

      100% {
        -webkit-transform: rotate(360deg);
        border-color: lightblue;
      }
    }
  }
</style>